import { render, staticRenderFns } from "./NewTHGCar.vue?vue&type=template&id=1e30ddf8"
import script from "./NewTHGCar.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewTHGCar.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports